require('./bootstrap');

import {createApp, registerRuntimeCompiler} from "vue";
import mitt from 'mitt';
import VueGtag, {useGtag, useState} from "vue-gtag-next";
import { VueReCaptcha } from 'vue-recaptcha-v3';
import Popper from "vue3-popper";
import LazyLoad from "vanilla-lazyload";
import { Tooltip, Popover, Carousel } from 'bootstrap';

if (document.getElementById('app')) {
    const emitter = mitt();
    const app = createApp({
        created() {
            let app = document.getElementById('app');
            let pageTakeover = document.getElementsByClassName('page-takeover')[0];

            if(pageTakeover != null) {

                let takeoverUrl = pageTakeover.getAttribute('data-page-takeover-url')
                
                // // Sets the takeover background to be clickable, but only if clicked outside of the header/footer/container elements 
                pageTakeover.addEventListener('click', (event) => {
                    if(event.target == pageTakeover || event.target == app)
                    {
                        if(takeoverUrl != '')
                        {
                            window.open(takeoverUrl, '_blank');
                        }
                    }
                });

                /* Changes the cursor to pointer, to mirror a link hover effect */
                pageTakeover.addEventListener('mousemove', (event) => {
                    if(event.target == pageTakeover || event.target == app) {
                        if(takeoverUrl != '')
                        {
                            pageTakeover.style.cursor = 'pointer';
                        }
                    }
                    else
                    {
                        pageTakeover.style.cursor = 'auto';
                    }
                });
            }
        },
        data() {
            return {
                
            }
        },
        mounted() {
            init_tooltip();
            init_popover();
            this.updateBrandCount();
            this.emitter.on('refreshTooltips', data => {
                this.initTooltip();
            });
            this.emitter.on('initPopovers', data => {
                this.initPopover();
            });
        },
        methods: {
            initTooltip: function() {
                init_tooltip()
            },
            initPopover: function() {
                init_popover()
            },
            async updateBrandCount() {
                var brandCountElement = document.getElementById('nav-brand-count');
                var brandCount = brandCountElement.getAttribute('data-nav-brand-count');

                if(brandCount == '') {
                    var response = await axios.get('/ajax/get_brand_count');
                    brandCountElement.innerHTML = response.data[0];
                }
            },
            createUrl: function(request_url) {
                var baseUrl = this.getMeta('base_url');

                // Check if the request_url starts with a slash, since the base_url will always contain a trailing slash
                if (request_url.charAt(0) == "/") {
                    request_url = request_url.slice(1);
                }

                if (baseUrl.length > 1) {
                    // if the requesting url contains the base_url already, then remove the base url from the request
                    request_url = request_url.replace(baseUrl, '');
                }

                return baseUrl + request_url;
            },
            getMeta(metaName) {
                const metas = document.getElementsByTagName('meta');
              
                for (let i = 0; i < metas.length; i++) {
                  if (metas[i].getAttribute('name') === metaName) {
                    return metas[i].getAttribute('content');
                  }
                }
              
                return '';
            }
        }
    });

    app.use(VueGtag);
    if(window.document.querySelector("#contact")) {
        app.use(VueReCaptcha, {
            siteKey: '6LdzB0gqAAAAAOj2zpq_QzUaim-AL1G_4Gf7Oktb'
        })
    }

    const {query} = useGtag();

    if(window.document.querySelector("meta[name=advertising_cookies_allowed]")) {
        query('consent', 'default', {
            'ad_storage': 'granted',
            'ad_user_data': 'granted',
            'ad_personalization': 'granted'
        });
    }
    else {
        query('consent', 'default', {
            'ad_storage': 'denied',
            'ad_user_data': 'denied',
            'ad_personalization': 'denied'
        });
    }

    if(window.document.querySelector("meta[name=performance_cookies_allowed]")) {
        query('consent', 'default', {
            'analytics_storage': 'granted',
        });
    }
    else {
        query('consent', 'default', {
            'analytics_storage': 'denied',
        });
    }

    const { property } = useState();

    property.value = [
        {
            id: 'G-6GF7E01QV1',
            params: {
                send_page_view: true
            },
            default: true
        },
        {
            id: 'G-BXNJ4GH8EX',
            params: {
                send_page_view: true
            }
        }
    ];

    app.use(Popper);

    //Intercepting axios requests to prepend baseUrl to all requests, for proxy reasons <(^.^)>
    var baseUrlMeta = document.querySelector('meta[name="base_url"]').content.slice(0, -1);

    app.config.compilerOptions.delimiters = ["@{{", "}}"];
    app.config.globalProperties.emitter = emitter;
    app.config.globalProperties.baseUrl = baseUrlMeta;
    
    axios.interceptors.request.use(function(config) {
        config.url = baseUrlMeta + config.url;
        return config;
    });

    // Get all components inside components folder (including subfolders)
    const requireComponent = require.context("./components/", true, /\.vue$/i);

    // Register each base component with their file name as component name.
    requireComponent.keys().map((path) => {
        const component = requireComponent(path);

        // Get name to use for component
        const componentName = path.split("/").pop()?.replace(/\.\w+$/, "");

        app.component(componentName, component.default || component);
    });

    // Get all components inside platform (shared) component folder (including subfolders)
    const requireBackendComponent = require.context("@shared/components/", true, /\.vue$/i);

    // Register each base component with their file name as component name.
    requireBackendComponent.keys().map((path) => {
        const component = requireBackendComponent(path);

        // Get name to use for component
        const componentName = path.split("/").pop()?.replace(/\.\w+$/, "");

        app.component(componentName, component.default || component);
    });

    app.mount("#app");
} else {
    init_tooltip();
}

function init_tooltip() {
    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))

    // Remove tooltips that may be open currently
    document.querySelectorAll('.bs-tooltip-auto').forEach(element => element.remove());

    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new Tooltip(tooltipTriggerEl)
    })
}

function init_popover() {
    var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
    var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
        return new Popover(popoverTriggerEl)
    })
}

// https://www.andreaverlicchi.eu/vanilla-lazyload/
var lazyLoadInstance = new LazyLoad();